const value = {
    integer: 'Enter an integer',
    validationError: 'Validation error',
    unknownError: 'Unknown error',
    notMoreThanSymbols: 'Max {{number}} characters',
  };

export default value;
